import { getEnv } from '@atlassian/pillar/runtime/env';

// Use a getter function to safely access window.location.origin
// This prevents issues in test environments where window might not be available
export const getDefaultTenantBaseUrl = (): string => {
	if (typeof window !== 'undefined' && window.location) {
		return window.location.origin;
	}
	return 'https://teamwork-graph.atlassian.com'; // fallback for test environments
};

/**
 * PROD: https://hello.atlassian.net
 */
export const HELLO_CLOUD_ID_PROD = 'a436116f-02ce-4520-8fbb-7301462a1674';
export const HELLO_ORG_ID_PROD = '2346a038-3c8c-498b-a79b-e7847859868d';

/**
 * STG: https://atlassian-studio-playground-experience.jira-dev.com
 */
export const STUDIO_PLAYGROUND_CLOUD_ID_STG = 'ff4f56fc-6582-4084-941c-c0d04c0ab3f9';
export const STUDIO_PLAYGROUND_ORG_ID_STG = 'b22713c4-510c-4963-9510-04eacd449f6a';

export const DEFAULT_TENANT_BASE_URL: string = getDefaultTenantBaseUrl();
export const DEFAULT_LABS_CLOUD_ID: 'a436116f-02ce-4520-8fbb-7301462a1674' = HELLO_CLOUD_ID_PROD;
/**
 * PROD: https://one-atlas-qdiv.atlassian.net
 */
export const DEFAULT_QUERY_BUILDER_CLOUD_ID = 'a32e5600-cd47-41af-9fa5-ca64b7866880';
export const DEFAULT_QUERY_BUILDER_QUERY_CONTEXT: 'ari:cloud:platform::site/a32e5600-cd47-41af-9fa5-ca64b7866880' = `ari:cloud:platform::site/${DEFAULT_QUERY_BUILDER_CLOUD_ID}`;

export const SLACK_CHANNEL_URL = 'https://atlassian.enterprise.slack.com/archives/C07JC999EBH';
export const DOWNLOAD_RESULTS_FILENAME = 'twg-results.json';

export const CYPHER_CRASH_COURSE_URL =
	'https://developer.atlassian.com/cloud/ari-graph-store/using-ugs/cypher/crash-course/';
export const CYPHER_API_USAGE_URL =
	'https://developer.atlassian.com/cloud/ari-graph-store/using-ugs/cypher/api-usage/';
export const LABS_ROADMAP_URL =
	'https://hello.atlassian.net/wiki/spaces/TEAMGRAPH/pages/6502917642/Teamwork+Graph+Labs+Roadmap+Q3';
export const SHARE_FEEDBACK_URL =
	'https://softwareteams.atlassian.net/jira/software/projects/GI/form/1558';
export const GRAPHQL_TROUBLESHOOTING_URL =
	'https://atlassian.slack.com/archives/C09RFLK60AG/p1762813935759469?thread_ts=1762812477.951999&cid=C09RFLK60AG';
export const SIGNALFX_DASHBOARD_BASE =
	'https://atlassian.signalfx.com/#/dashboard/G6jwP0HA4AY?groupId=G6jwP0FA0AY&configId=G6jwRA8AwAA&startTime=-15m&endTime=Now&variables%5B%5D=';
export const ROVO_DEV_DOCS_URL =
	'https://support.atlassian.com/rovo/docs/turn-rovo-dev-features-on-and-off/';
export const ROVODEV_SESSION_BASE_URL = 'https://hello.atlassian.net/rovodev/flow/s/';

export const QUERY_CONTEXT_HEADER = 'X-Query-Context';
export const RESULTS_CONTAINER_TEST_ID = 'query-results-container';

// PUG staging cloud ID — UGS can't determine an org from a user ARI alone,
// so staging consumers must pass the PUG site ARI as X-Query-Context.
export const PUG_CLOUD_ID_STG = 'DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5';
export const PUG_ORG_ID_STG = '3f97e0d7-a8ca-4263-91bf-3015999c8e64';

/**
 * Get the appropriate cloud ID based on the environment
 */
export const getDefaultTenantCloudId = (): string => {
	const env = getEnv();
	// Use staging cloud ID for local and staging environments
	if (env === 'local' || env === 'development' || env === 'staging') {
		return STUDIO_PLAYGROUND_CLOUD_ID_STG;
	}
	// Use production cloud ID for production
	return DEFAULT_LABS_CLOUD_ID;
};

export const DEFAULT_TENANT_CLOUD_ID: string = getDefaultTenantCloudId();
export const TWG_SELECTED_MOCK = 'twg:selected-mock';
export const TWG_ENABLE_MOCKS = 'twg:enable-mocks';
export const TWG_MOCK_ENABLED = 'twg:mock-enabled';
export const TWG_ENABLE_SMART_LINKS = 'twg:enable-smart-links';
